import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";
import login from "@/store/modules/login";
import bookeditgeneral from "./modules/bookedit-general";
import features from "./modules/features";

let modules = {
  login,
  bookeditgeneral,
  features
};
// Only persist login state
let plugins = [
  createPersistedState({
    paths: [
      "login.theme", 
    ],
  }),
];

let store = createStore({
  modules,
  plugins
});

export { store, modules, plugins,features };
